import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "application-info-content-wrapper"
}
const _hoisted_3 = { class: "loans-to-refinance-section-wrapper" }

import Tile from "@/components/shared/Tile.vue";
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import LoansToRefinanceTable from "@/components/refi-loans-table/LoansToRefinanceTable.vue";
import RefiLoanConfigurationDetails from "@/components/refi-loan-configuration/RefiLoanConfigurationDetails.vue";
import Loader from "@/components/shared/Loader.vue";
import { ApplicationStatusTypeIds } from "@/config/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationInfoREFI',
  props: {
  application: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();

const gettingData = ref<boolean>(true);

const applicationStatusId = computed(() => store.state.appData?.application?.applicationStatusId);
const currentApplicant = computed(() => store.state.appData?.currentApplicant);

async function getRefiDetails() {
  await store.dispatch("applicationInfoModule/getRefiDetails", props.application?.id);

  if (
    applicationStatusId.value === ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING ||
		applicationStatusId.value === ApplicationStatusTypeIds.RIGHT_TO_CANCEL ||
    applicationStatusId.value === ApplicationStatusTypeIds.COMPLETE
  ) {
    store.dispatch("consentsModule/setCurrentApplicant", currentApplicant.value);
    await store.dispatch("consentsModule/getConsentsForAllApplicants");
  }

  gettingData.value = false;
}

onMounted(() => {
  getRefiDetails();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("p", { class: "title" }, "Your Refinance Details")
      ], -1)),
      (gettingData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(Loader)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LoansToRefinanceTable, {
                showIncludedLoansOnly: true,
                showAddLoanButton: false,
                id: "ApplicationInfoTile"
              })
            ]),
            _createVNode(RefiLoanConfigurationDetails)
          ]))
    ]),
    _: 1
  }))
}
}

})